import { z } from 'zod';
import { isQuoteProgramOption } from '@/lib/quote-programs';

/**
 * A "Program Selection" value: one of the quote dropdown's option strings,
 * or empty. Shared by the quote form (where the first pick is required) and
 * the contact form (where a program page pre-fills it and nothing else does).
 */
export const programSelectionSchema = z
  .string()
  .trim()
  .max(160)
  .refine((value) => value === '' || isQuoteProgramOption(value), 'Unknown program');

/** The field both forms carry the pick in — the Pardot handlers' "Program Selection 1". */
export const PROGRAM_FIELD = 'programSelection1';
